import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { DatePickerTime } from 'shared_DEPRECATED/components/Form/DatePicker';
import { dateUtils } from 'shared_DEPRECATED/utils';

import { CoachingMode } from 'features/participants/config/types';
import {
  COACHING_MODE_SESSION_DURATION,
  DEFAULT_SESSION_DURATION,
} from 'features/sessions/config';
import {
  getDateStringWithUpdatedTime,
  getSessionEndTime,
} from 'features/sessions/utils';

import { Typography } from 'shared/components/Typography';

export const SessionsFormEndTimeSelector = () => {
  const { setValue } = useFormContext();
  const sessionStartDate = useWatch({ name: 'startAt' });
  const sessionEndDate = useWatch({ name: 'endAt' });
  const coachingMode = useWatch({ name: 'coachingMode' }) as CoachingMode;

  const filterSessionEndDateTime = (endDate: Date) =>
    dateUtils(endDate).isAfter(sessionStartDate);

  const onTimeChange = (date: Date) => {
    const updatedEndDate = getDateStringWithUpdatedTime(sessionEndDate, date);

    setValue('endAt', updatedEndDate, {
      shouldDirty: true,
    });

    const isSelectedDateBeforeStartDate =
      dateUtils(updatedEndDate).isSameOrBefore(sessionStartDate);

    if (isSelectedDateBeforeStartDate) {
      const sessionStartDate = dateUtils(updatedEndDate)
        .subtract(
          COACHING_MODE_SESSION_DURATION[coachingMode] ||
            DEFAULT_SESSION_DURATION,
          'minute'
        )
        .toISOString();

      setValue('startAt', sessionStartDate);
    }
  };

  useEffect(() => {
    if (dateUtils(sessionEndDate).isSameOrBefore(sessionStartDate)) {
      const sessionEndDate = getSessionEndTime(sessionStartDate, coachingMode);
      setValue('endAt', sessionEndDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionEndDate]);

  return (
    <Typography as="div" type="meta" dataTestid="session-end-time">
      <DatePickerTime
        date={dateUtils(sessionEndDate).toDate()}
        onChange={onTimeChange}
        filterTime={filterSessionEndDateTime}
      />
    </Typography>
  );
};
